angular.module 'app'
.controller 'UserLayoutCtrl', ($stateParams, $scope, $http, config, Storage) ->
  $scope.permission = Storage.get('user_permission')
